import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainMenuComponent } from './main-menu.component';
import { ConfirmationComponent, IconComponent, TextComponent } from 'ui-kit';
import { MenuItemComponent } from './menu-item/menu-item.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatTooltip } from "@angular/material/tooltip";



@NgModule({
  declarations: [
    MainMenuComponent,
    MenuItemComponent
  ],
  exports: [
    MainMenuComponent
  ],
  imports: [
    CommonModule,
    IconComponent,
    RouterLink,
    RouterLinkActive,
    MatTooltip,
    ConfirmationComponent,
    TextComponent
  ]
})
export class MainMenuModule { }
